var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"65C2C3D0-B3A3-4D09-8602-07F778F1E3EF"),React.createElement("desc",{"key":1},"Created with sketchtool."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"(Web)-Joyful-Schedule_Events-Past","transform":"translate(-221.000000, -385.000000)","stroke":"#43B649","strokeWidth":"3"},React.createElement("polyline",{"id":"Path-2","points":"223 390.884097 227.399786 396 236 386"})))]);
}

Check.defaultProps = {"width":"17px","height":"14px","viewBox":"0 0 17 14","version":"1.1"};

module.exports = Check;

Check.default = Check;
